import { Link } from 'react-router-dom'

export function Home() {
  return (
    <main className="mx-auto mt-10 max-w-3xl px-4">
      <section className="glass-strong p-8">
        <h1 className="mb-3 text-3xl font-extrabold tracking-tight">
          bskydisc<span className="accent-text">o</span>mbobulate
        </h1>
        <p className="text-ink-200">
          A glass-themed AT Protocol viewer. Fork of{' '}
          <a className="accent-text underline" href="https://bskyviewer.github.io/" target="_blank" rel="noreferrer">
            bskyviewer
          </a>
          , now backed by a real API, an incremental cache, and an export pipeline.
        </p>
        <ul className="mt-4 list-disc pl-5 text-sm text-ink-200">
          <li>Browse posts, reposts, likes, follows, blocks for any handle.</li>
          <li>"Load entire feed" with progress bar and time estimate.</li>
          <li>Cached server-side; subsequent loads only fetch what's new.</li>
          <li>Export to text, JSON, or PDF (PDF includes images).</li>
          <li>Optional sign-in via app password from <code>Settings</code>.</li>
        </ul>
        <p className="mt-6 text-sm text-ink-300">
          Try a profile:{' '}
          <Link className="accent-text underline" to="/profile/jay.bsky.team">
            jay.bsky.team
          </Link>
          ,{' '}
          <Link className="accent-text underline" to="/profile/pfrazee.com">
            pfrazee.com
          </Link>
          .
        </p>
      </section>
    </main>
  )
}
